import React, { lazy, Suspense } from "react";
import Loader from "../components/Loader";

// ✅ Lazy Imports
const PersonalityCard = lazy(() =>
  import("../components/PersonalityCard").then((module) => ({
    default: module.PersonalityCard,
  }))
);

const AthleteResources = lazy(() =>
  import("../components/AthleteResources.jsx").then((module) => ({
    default: module.AthleteResources,
  }))
);

const HaryanaVenuesGallery = lazy(() =>
  import("../components/venus&facilities/SportsGallery").then((module) => ({
    default: module.HaryanaVenuesGallery,
  }))
);

const EventsSection = lazy(() =>
  import("../components/hoaUpComingEvents/EventsSection").then((module) => ({
    default: module.EventsSection,
  }))
);

const DignitariesSection = lazy(() =>
  import("../components/DignitariesSection").then((module) => ({
    default: module.DignitariesSection,
  }))
);

const ImageCarousel = lazy(() =>
  import("../components/slider/ImageCarousel").then((module) => ({
    default: module.ImageCarousel,
  }))
);

const HeroSection = lazy(() =>
  import("../components/HeroSection").then((module) => ({
    default: module.HeroSection,
  }))
);

const NewsSection = lazy(() =>
  import("../components/combinedSectionhome/NewsSection").then((module) => ({
    default: module.CombinedHOASection,
  }))
);


function HomePage() {
  return (
    <Suspense
      fallback={<Loader />}
    >
      <ImageCarousel />
      <HeroSection />
      <NewsSection />
      <DignitariesSection />
      <EventsSection /> 
      <HaryanaVenuesGallery />
      <PersonalityCard />
      <AthleteResources slug="athlete-resources" />
    </Suspense>
  );
}

export default HomePage;